// Settings.js
import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1>Settings Screen</h1>
      {/* Add your settings content here */}
    </div>
  );
};

export default Settings;
